<template src="./loja.html"></template>
<style lang="less" src="./loja.less" scoped></style>
<script>
import FooterApp from "./components/footer/footer-app";
import Loading from "@/components/loadings/loading/loading";
import PerfilDaLoja from "@/modules/loja/perfil/perfil-da-loja";
import CarrinhoDeCompras from "./produto/carrinho/carrinho-de-compras";
import MenuCategoriasProduto from "./menu/categorias/menu-categorias-produto";
import { mapState, mapActions } from "vuex";

const Perfil = "PerfilDaLoja";
const alturaParaFixagemDasCategorias = 580;
const larguraPadraoParaFixagem = 1024;
export default {
  components: {
    FooterApp,
    Loading,
    PerfilDaLoja,
    CarrinhoDeCompras,
    MenuCategoriasProduto,
  },
  data() {
    return {
      pageClass: "",
      campoDeBusca: "",
      showBotaoScroll: false,
      positionFixed: false,
      larguraAtualDaTela: window.innerWidth,
    };
  },
  computed: {
    ...mapState(Perfil, ["perfil", "loading"]),
    exibirScrollMobile() {
      return this.showBotaoScroll;
    },
    mobile() {
      return this.larguraAtualDaTela < 765;
    },
  },
  watch: {
    $route(to, from) {
      this.pageClass = to.name;
    },
  },
  created() {
    window.addEventListener("resize", this.ajustarTamanhoAtualDaTela);
    this.pageClass = this.$route.name;
    this.fetch({ errorCallback: this.irParaAPaginaNaoEncontrada });
  },
  methods: {
    ...mapActions(Perfil, ["fetch"]),

    irParaAPaginaNaoEncontrada() {
      this.$router.push({ name: "pagina-nao-encontrada" });
    },
    ajustarTamanhoAtualDaTela(e) {
      this.larguraAtualDaTela = window.innerWidth;
    },
    onPesquisaRealizada(valorPesquisa) {
      const routeListagemName = "produto-listagem"
      if(this.$router?.history?.current?.name !== routeListagemName)
        this.$router.push({ name: routeListagemName });
      this.campoDeBusca = valorPesquisa;
    },
    showBotaoScrollTopo() {
      if (window.scrollY > 290) {
        this.showBotaoScroll = true;
      } else {
        this.showBotaoScroll = false;
      }
    },
    fixaMenuQuandoScrollado() {
      if (
        window.scrollY > alturaParaFixagemDasCategorias &&
        window.innerWidth > larguraPadraoParaFixagem
      ) {
        this.positionFixed = true;
      } else {
        this.positionFixed = false;
      }
    },
  },
};
</script>